/* Holiday & Seasonal dropdown.
   The panel is shown by CSS alone (:hover, keyboard :focus-visible, or .is-open), so it works even if this script fails.
   This script only (a) toggles .is-open on click/tap, (b) keeps aria-expanded truthful, (c) Escape / ArrowDown / outside click.
   pointerType '' (synthetic input) is treated as a mouse; touch is excluded from hover handling. */
(function () {
  var items = document.querySelectorAll('[data-bt-dd]');
  if (!items.length) return;
  items.forEach(function (dd) {
    var btn = dd.querySelector('.bt-dd__summary');
    var panel = dd.querySelector('.bt-dd__panel');
    if (!btn || !panel) return;
    var timer = null;
    function visible() {
      var cs = window.getComputedStyle(panel);
      return cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.01;
    }
    function sync() { btn.setAttribute('aria-expanded', visible() ? 'true' : 'false'); }
    function hoverOpen() {
      dd.classList.remove('is-dismissed');
      btn.setAttribute('aria-expanded', 'true');
    }
    function hoverClose() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        dd.classList.remove('is-dismissed');
        if (!dd.classList.contains('is-open')) btn.setAttribute('aria-expanded', 'false');
        sync();
      }, 320);
    }
    function isTouch(e) { return e && e.pointerType === 'touch'; }
    if (window.PointerEvent) {
      dd.addEventListener('pointerenter', function (e) { if (isTouch(e)) return; clearTimeout(timer); hoverOpen(); });
      dd.addEventListener('pointerleave', function (e) { if (isTouch(e)) return; hoverClose(); });
    }
    /* mouse events as well: some synthetic / emulated input only fires these */
    dd.addEventListener('mouseenter', function () { clearTimeout(timer); hoverOpen(); });
    dd.addEventListener('mouseleave', hoverClose);
    btn.addEventListener('click', function () {
      var open = !dd.classList.contains('is-open');
      dd.classList.remove('is-dismissed');
      dd.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    btn.addEventListener('focus', function () {
      var kb = false;
      try { kb = btn.matches(':focus-visible'); } catch (err) { kb = false; }
      if (kb) hoverOpen();
    });
    dd.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !dd.contains(e.relatedTarget)) {
        dd.classList.remove('is-open', 'is-dismissed');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
    dd.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        dd.classList.remove('is-open');
        dd.classList.add('is-dismissed');
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
        return;
      }
      if (e.key === 'ArrowDown') {
        var first = panel.querySelector('a');
        if (first) { e.preventDefault(); dd.classList.remove('is-dismissed'); dd.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); first.focus(); }
      }
    });
    document.addEventListener('pointerdown', function (e) {
      if (!dd.contains(e.target) && (dd.classList.contains('is-open') || dd.classList.contains('is-dismissed'))) {
        dd.classList.remove('is-open', 'is-dismissed');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });
})();
